import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import MProductLookUp from "./MProductLookUp";
import { v4 as uuid } from "uuid";
import AutoComplete from "components/AutoComplete";
import { useDispatch } from "react-redux";
import authHeader from "services/auth-header";
import API from "services/axios";
import { setNotification } from "features/Notification/notificationSlice";
import MOProductWages from "./MOProductWages";

export default function MProductDetails({
  productTypes,
  fabrics,
  formData,
  setFormData,
  isViewOnly = false,
  setSelectedProduct,
}) {
  /*   All States
   ********************************************* */
  const dispatch = useDispatch();

  const [showLockupForm, setShowLockupForm] = useState(null);

  const addSizesFromProduct = (product) => {
    // Get sizes from the product
    const productSizes = product.sizesWithNames || [];

    // Create new size entries for each size in the product
    const newSizes = productSizes.map((sizeName, index) => {
      return {
        size: sizeName,
        quantity: "0",
        price: "0",
        cost: 0,
        id: uuid(),
        sortId: index + 1,
      };
    });

    // Sort by sortId
    newSizes.sort((a, b) => a.sortId - b.sortId);

    // Return the JSON string of the new sizes array
    return JSON.stringify(newSizes);
  };

  /*   All Functions
   ********************************************* */
  const handleSelectedProduct = (product) => {
    let _productSizes = addSizesFromProduct(product);

    let _productFabric = fabrics?.find(
      (fabric) => fabric.fabricId === product.fabricId
    );
    _productFabric = _productFabric ? _productFabric.name : "";

    let _formData = {
      ...formData,
      productStyle: product.styleId,
      productWageId: "",
      productDescription: product.desc,
      productType: product.productType?.productTypes,
      productSizes: _productSizes,
      productFabric: _productFabric,
      productUrl: product.productUrl || "",
    };

    setFormData((prev) => _formData);
    // setSelectedProduct((prev) => _formData);
    setShowLockupForm(false);
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    console.log(formData);
  }, [formData]);

  return (
    <div>
      <div className=" p-1">
        <div className="row mb-1">
          <label className="col-5">Product Type</label>
          <div className="col-7">
            <select
              disabled={isViewOnly}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  productType: e.target.value,
                })
              }
              value={formData?.productType || ""}
              className="form-select"
              id="commision_type"
              required
            >
              <option value={""}>Select Product Type</option>
              {productTypes &&
                productTypes.map((productType, i) => (
                  <option key={i} value={productType.productTypes}>
                    {productType.type}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="row mb-1">
          <label className="col-5">Product Style</label>
          <div className="col-7 d-flex align-items-center">
            <div className="input-group">
              <button
                onClick={() => {
                  setShowLockupForm(true);
                }}
                type="button"
                className="btn btn-sm btn-info"
              >
                L
              </button>
              <input
                type="text"
                className="form-control"
                required
                readOnly={isViewOnly}
                value={formData?.productStyle}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    productStyle: e.target.value,
                  })
                }
                placeholder="Enter product style"
              />
            </div>
          </div>
        </div>
        <div className="row mb-1">
          <label className="col-5">Product Description</label>
          <div className="col-7 ">
            <input
              type="text"
              readOnly={isViewOnly}
              value={formData?.productDescription}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  productDescription: e.target.value,
                })
              }
              className="form-control"
              placeholder="Product description"
            />
          </div>
        </div>
        <div className="row mb-1">
          <label className="col-5">Product Fabric</label>
          <div className="col-7 ">
            {/* products select */}
            <select
              disabled={isViewOnly}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  productFabric: e.target.value,
                })
              }
              value={formData?.productFabric || ""}
              className="form-select"
              id="product_fabric"
              required
            >
              <option value={""}>Select Product Fabric</option>
              {fabrics &&
                fabrics?.map((fabric, i) => (
                  <option key={i} value={fabric.name}>
                    {fabric.name}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="row mb-1">
          <label className="col-5">Product Color</label>
          <div className="col-7 ">
            <input
              type="text"
              readOnly={isViewOnly}
              value={formData?.productColor}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  productColor: e.target.value,
                })
              }
              className="form-control"
              placeholder="Product color"
            />
          </div>
        </div>

        <div className="row mb-1">
          <label className="col-5">Team Name</label>
          <div className="col-7 ">
            <input
              type="text"
              readOnly={isViewOnly}
              value={formData?.teamName || ""}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  teamName: e.target.value,
                })
              }
              className="form-control"
              placeholder="Team Name"
            />
          </div>
        </div>
        <div className="row mb-1">
          <label className="col-5">Select Wage</label>
          <div className="col-7 ">
            <MOProductWages
              formData={formData}
              setFormData={setFormData}
              isViewOnly={isViewOnly}
            />
          </div>
        </div>
      </div>
      <Modal
        show={showLockupForm}
        onHide={() => setShowLockupForm(false)}
        centered
        size="lg"
        // backdrop="static"
        // keyboard={false}
        contentClassName="bg-white custom-shadow-sm custom-border-radius"
      >
        <Modal.Body>
          <h3 className="">Select Product</h3>
          <hr className="mt-0 mb-3" />
          <MProductLookUp
            handleSelectedProduct={handleSelectedProduct}
            formData={formData}
            isShowModal={showLockupForm}
          />
          <div className="text-end">
            <button
              onClick={() => setShowLockupForm(false)}
              type="button"
              className="btn btn-sm btn-secondary mt-2"
            >
              Close
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
